import { FINANCIAL_DISCLAIMER_HEADING, FINANCIAL_DISCLAIMER_POINTS } from './tradingDisclaimer';

type DisclaimerModalProps = {
  open: boolean;
  mode?: 'blocking' | 'info';
  acceptedAt?: string | null;
  onAccept?: () => void;
  onClose?: () => void;
};

function AcceptedStamp({ acceptedAt }: { acceptedAt?: string | null }) {
  if (!acceptedAt) return null;

  return (
    <p className="text-xs text-text-muted">
      Accepted on {new Date(acceptedAt).toLocaleString()}
    </p>
  );
}

export function DisclaimerModal({
  open,
  mode = 'blocking',
  acceptedAt = null,
  onAccept,
  onClose,
}: DisclaimerModalProps) {
  if (!open) return null;

  const infoMode = mode === 'info';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-3xl rounded-2xl border border-border bg-bg-secondary shadow-2xl shadow-black/40">
        <div className="border-b border-border px-6 py-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs uppercase tracking-[0.24em] text-accent">
                Trading Disclaimer
              </p>
              <h2 className="mt-2 text-lg font-semibold text-text-primary">
                {FINANCIAL_DISCLAIMER_HEADING}
              </h2>
            </div>
            {infoMode && onClose ? (
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg border border-border px-3 py-1.5 text-xs text-text-muted hover:text-text-primary"
              >
                Close
              </button>
            ) : null}
          </div>
        </div>

        <div className="max-h-[65vh] space-y-4 overflow-y-auto px-6 py-5">
          <p className="text-sm text-text-secondary">
            Review and accept this disclosure before using trading-related features.
          </p>

          <div className="space-y-3">
            {FINANCIAL_DISCLAIMER_POINTS.map((point) => (
              <div
                key={point}
                className="rounded-xl border border-border bg-bg-primary/60 px-4 py-3 text-sm text-text-secondary"
              >
                {point}
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-border px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
          <AcceptedStamp acceptedAt={acceptedAt} />
          {infoMode ? (
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg bg-accent px-4 py-2 text-sm font-medium text-white hover:opacity-90"
            >
              Acknowledge
            </button>
          ) : (
            <button
              type="button"
              onClick={onAccept}
              className="rounded-lg bg-accent px-4 py-2 text-sm font-medium text-white hover:opacity-90"
            >
              I Accept and Understand
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
